import {
  ComponentPropsWithoutRef,
  CSSProperties,
  ElementType,
  ReactNode,
} from 'react';

import { cn } from '../../lib';

type TStarBorderProps<T extends ElementType> = ComponentPropsWithoutRef<T> & {
  as?: T;
  className?: string;
  children?: ReactNode;
  color?: string;
  speed?: CSSProperties['animationDuration'];
  thickness?: number;
};

export function AnimatedBorder<T extends ElementType = 'button'>({
  as,
  className = '',
  color = 'white',
  speed = '2s',
  thickness = 1,
  children,
  ...rest
}: TStarBorderProps<T>) {
  const Component = as || 'button';

  return (
    <Component
      className={cn('relative inline-block overflow-hidden', className)}
      {...(rest as any)}
      style={{
        // padding: `${thickness}px 0`,
        ...(rest as any).style,
      }}
    >
      <div
        className="animate-star-movement-bottom absolute bottom-[-1px] right-[-250%] z-0 h-[50%] w-[300%]"
        style={{
          background: `radial-gradient(circle, ${color}, transparent 20%)`,
          animationDuration: speed,
        }}
      />
      <div
        className="animate-star-movement-top absolute left-[-250%] top-[-1px] z-0 h-[50%] w-[300%]"
        style={{
          background: `radial-gradient(circle, ${color}, transparent 20%)`,
          animationDuration: speed,
        }}
      />
      <div className="z-1 relative rounded-md bg-gray-50 px-2 py-2 dark:bg-gray-700">
        {children}
      </div>
    </Component>
  );
}
